import React, { FC } from 'react';
import { Container, Grid, Box, Typography, makeStyles } from '@dxb-web-ui-framework/design-system';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';
import { HeroContent } from '../types';

type HeroBannerProps = {
  heroImage?: string;
  content?: HeroContent;
  moto?: string;
  slogan?: string;
};

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  img: {
    'object-fit': 'cover',
    'margin-left': 50,
    [breakpoints.down('sm')]: {
      'margin-left': 0,
    },
  },
  container: {
    'margin-bottom': spacing(1),
  },
  grid: {
    marginLeft: 'auto',
  },
}));

// TODO: add the hero banner bg image and style it to be as per designs with padding and positioning
const DashboardHeroBanner: FC<HeroBannerProps> = ({ heroImage, moto, slogan, content }) => {
  const { isExtraSmallScreen: isMobile } = useScreenDetector();

  const classes = useStyles();

  return (
    <Container maxWidth={isMobile ? 'sm' : 'lg'} className={classes.container}>
      <Grid container spacing={4} className={classes.grid}>
        <Grid item xs={6}>
          <Box display='flex' justifyContent='center' flexDirection='column' height='100%'>
            <Box display='flex' justifyContent='center'>
              {moto && <Typography variant={isMobile ? 'h5' : 'h3'}>{moto}</Typography>}
            </Box>
            <Box display='flex' justifyContent='flex-end'>
              {slogan && (
                <Typography variant={isMobile ? 'h4' : 'h2'} color='primary'>
                  {slogan}
                </Typography>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <img
            src={heroImage}
            width={isMobile ? '70%' : '35%'}
            height='100%'
            className={classes.img}
            alt={`${moto} ${slogan}`}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export { DashboardHeroBanner };
